import { render, staticRenderFns } from "./LogbookFilters.vue?vue&type=template&id=c3104412&scoped=true"
import script from "./LogbookFilters.vue?vue&type=script&lang=js"
export * from "./LogbookFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3104412",
  null
  
)

export default component.exports